<template>
  <AttentionModal
    :title="title"
    :body="body"
    :visible="attentionModalVisible"
    @close="attentionModalVisible = false"
  />
</template>

<script>
import axios from 'axios';
import config from '@/config';
import AttentionModal from '../modals/AttentionModal.vue';

const { endpoints } = config.page;

export default {
  name: 'Attention',
  components: {
    AttentionModal,
  },
  data() {
    return {
      title: '',
      body: '',
      attentionModalVisible: false,
    };
  },
  created() {
    axios({ url: endpoints.page('attention') })
      .then(({ data }) => {
        this.body = data.Body;
        this.title = data.Title;

        if (!sessionStorage.getItem(data.Title)) {
          this.attentionModalVisible = true;
          sessionStorage.setItem(data.Title, false);
        }
      })
      .catch(() => {
        this.attentionModalVisible = false;
      });
  },

  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
